import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useOutletContext } from 'react-router'

import { useNotifications } from 'app/application/application'
import { Form } from 'app/common/presentation'
import { useConnections } from 'app/connections/application'
import { GoogleAdwordsAdAccount } from 'app/connections/types'

import { Button } from 'components'

import connectStyles from '../../Connect.module.scss'
import { StepContext } from '../StepWithConnectionAndAccounts'
import { AccountsAndIdsStep } from './AccountsAndIdsStep/AccountsAndIdsStep'

const GoogleAdwordsSettings = () => {
  const navigate = useNavigate()
  const { createNotification, te } = useNotifications()
  const { accounts, connection } = useOutletContext<StepContext<GoogleAdwordsAdAccount>>()
  const { saveConnection } = useConnections()
  const { t } = useTranslation('connections')

  const [campaignId, setCampaignId] = useState<string>('')
  const [isSaving, setIsSaving] = useState<boolean>(false)

  const handleSave = useCallback(() => {
    setIsSaving(true)

    const connectionConfig = {
      accounts,
      campaignId,
    }

    void saveConnection(connection, connectionConfig)
      .then((result) => {
        if (result.ok) {
          createNotification({
            message: t('update.success.message', {
              name: t(`available.${connection.name}.displayName`),
            }),
            title: t('update.success.title'),
            type: 'success',
          })

          void navigate(`/connections/${connection.name}/setup`, { replace: true })
        } else {
          createNotification({
            message: result.val.message,
            title: te(`http.${result.val.code}`),
            type: 'error',
          })
        }
      })
      .finally(() => setIsSaving(false))
  }, [accounts, campaignId, createNotification, navigate, saveConnection, connection, t, te])

  return (
    <div>
      <AccountsAndIdsStep accounts={accounts} connection={connection}>
        <Form.InputFormRow
          description={t(`setup.${connection.name}.config.campaignId.description`)}
          onChange={setCampaignId}
          placeholder={t(`setup.${connection.name}.config.campaignId.title`)}
          title={t(`setup.${connection.name}.config.campaignId.title`)}
          value={campaignId}
        />
      </AccountsAndIdsStep>
      <div className={connectStyles.actions}>
        <Button onClick={() => void navigate(-1)} variant="secondary">
          {t('setup.actions.back')}
        </Button>
        <Button
          disabled={!campaignId}
          loading={isSaving}
          onClick={(e) => {
            e.stopPropagation()

            handleSave()
          }}
        >
          {t('setup.actions.finish')}
        </Button>
      </div>
    </div>
  )
}

export default GoogleAdwordsSettings
